// Author panyurou
// Date 2023-06-29 15:16:13

import * as model from "@/model/sithMes/agreement/SithMesAgreementModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesAgreement(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_AGREEMENT_URL,
    })
    .buildStore()
